import React from 'react';
import styled from '@emotion/styled';
import { Box, Flex, Image, Text } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import {
  display,
  fontSize,
  fontWeight,
  lineHeight,
  space,
  themeGet,
} from 'styled-system';

import onSale from './assets/On-sale.svg';

const StyledFlex = styled(Flex)`
  border-radius: ${themeGet('radii.md')};
  background: ${themeGet('colors.ui.badgeBackground')};
`;

const BannerText = styled(Text)`
  font-family: 'Jetstar';
  ${lineHeight};
  ${space};
  ${display};
  ${fontSize};
  ${fontWeight};
`;

const CampaignBanner = ({ message }) => (
  <Box data-testid="campaign-banner-wrapper">
    <StyledFlex p={['3', null, '6']} alignItems="center" boxShadow="light">
      <Image src={onSale} alt="Sale icon" width="40px" />
      <BannerText
        pl={['3', null, '5']}
        fontSize="base"
        fontWeight="bold"
        lineHeight="normal"
        color="black"
      >
        {message}
      </BannerText>
    </StyledFlex>
  </Box>
);

CampaignBanner.propTypes = {
  message: PropTypes.string.isRequired,
};

export default CampaignBanner;
